<template>

    <div class="grid grid-cols-4 gap-1 px-6 pt-6 md:pt-0 md:grid md:grid-cols-2 md:gap-1 md:px-0">
        <div class="w-16 h-16 border-2 md:w-auto md:h-auto sm:m-1 md:m-8 md:max-w-64 md:max-h-64">
            <img class="w-14 h-14 md:w-full md:h-full"
                    :src="item.image"
                    :alt="item.orderNr"
                >
        </div>
        <div class="col-span-3 md:col-span-1">
            <div class="font-semibold md:mt-8 md:text-xl">
                Pedido: {{ item.orderNr }}
            </div>
            <div class="font-semibold md:text-lg">
                {{ itemsCountLabel }}
            </div>
            <div class="text-xs font-normal md:text-sm 2xl:mt-6 xl:mt-1">
                Data de compra: <span class="font-semibold">{{ item.date }}</span>
            </div>
            <div class="text-xs font-normal md:text-sm ">
                Valor: <span class="font-semibold">R$ {{ item.grandTotal }}</span>
            </div>
            <div class="text-xs font-normal md:text-sm ">
                Compra efetuada em:
                <span v-if="item.marketplace !== null" class="font-semibold">{{ item.marketplace }}</span>
                <span v-else class="font-semibold">Mobly</span>
            </div>
            <div v-if="item.paymentMethod !== '' && item.paymentMethod !== null" class="text-xs font-normal md:text-sm ">
                    Forma de pagamento: <span class="font-semibold">{{ item.paymentMethod }}</span>
            </div>
            <div v-if="item.couponCode" class="text-xs font-normal md:text-sm ">
                    Cupom: <span class="font-semibold">{{ item.couponCode }}</span>
            </div>
            <div class="hidden md:block 2xl:mt-8 xl:mt-2">
                 <router-link id="routerDetails" class="hover:no-underline" :to="mountRouteWithParam">
                     <button
                        type="button"
                        class="text-lg font-semibold text-white rounded-lg xl:w-52 2xl:w-62 bg-purple-mobly hover:bg-purple-900 xl:h-9 2xl:h-12 rounded-xl focus:outline-none focus:ring-0"
                    >
                            Detalhes e atendimento
                    </button>
                </router-link>
            </div>
        </div>
        <div class="col-span-4 mt-3 mb-3 md:hidden">
                 <router-link id="routerDetailsMobile" class="hover:no-underline" :to="mountRouteWithParam">
                    <button
                        type="button"
                        class="font-semibold text-white rounded-lg h-9 w-72 bg-purple-mobly hover:bg-purple-900 rounded-xl focus:outline-none focus:ring-0"
                    >
                            Detalhes e atendimento
                    </button>
                </router-link>
            </div>
            <div v-show="item.covid" class="w-full col-span-3 px-1 md:col-span-1">
                <CovidList />
            </div>
    </div>

</template>

<script>
import namespace from '../../vuex/namespace'
import { mapState } from 'vuex'
import CovidList from '../Covid/CovidList'

export default {
  name: 'OrderBox',
  props: ['itemList'],
  components: {
    CovidList
  },
  computed: {
    ...mapState(namespace.ORDERS, [
      'list'
    ]),
    mountRouteWithParam: function () {
      return {
        path: `meus-pedidos/pedido/${this.item.orderNr}`
      }
    },
    itemsCountLabel: function () {
      const count = this.item.itemsCount
      return count + (count === 1 ? ' item' : ' itens')
    },
    item: function () {
      return this.itemList
    }
  }
}
</script>
